import CV from "../../assets/Luis_Esteban_Acevedo_Bringas_CV.pdf";
import { ReactTyped as Typed } from "react-typed";
import { Button } from "../../components";
import LB from "../../assets/LB.png";
import React from "react";
import "./landing.css";

// Papers imgs
// import egamnet from "../../assets/publications/EGAMNet.png";
import yolo3d from "../../assets/publications/yolo3d.png";
import gamnet from "../../assets/publications/GAMNet.png";

// site imgs
import jagaimo from "../../assets/projects/jagaimo.png";
import UEC_IW from "../../assets/projects/uec_IW.png"
import wiljo from "../../assets/projects/wiljo.png";
import avag from "../../assets/projects/avag.png";

// countries flgas
import newZealand from "../../assets/flags/newZealand.png";
import mexico from "../../assets/flags/mexico.png";
import japan from "../../assets/flags/japan.png";
import usa from "../../assets/flags/usa.png";

// tech
import javascript from "../../assets/skills/languages/js.png";
import react from "../../assets/skills/web/react.svg";
import html from "../../assets/skills/web/html.svg";
import css from "../../assets/skills/web/css.svg";

// components
import PublicationCard from "../../components/publicationCard/publicationCard";
import { ProjectCard } from "../../components";

const Landing = () => {
    return (
        <div>
            <section className="Portafolio__header" id="home">
                <div className="Portafolio__header-overlay"></div>
                    <div className="Portafolio__header-info">
                        <div className="Portafolio__location-badge">
                            <span className="location-dot"></span>
                            <span>Tokyo, Japan</span>
                        </div>

                        <div className="Portafolio__image-wrapper">
                            <img src={LB} alt="Luis Bringas" />
                        </div>

                        <div className="Portafolio__header-info_name">
                            <div className="glitch" data-text="Luis Bringas">
                            Luis Bringas
                            </div>
                        </div>

                        <div className="Portafolio__header-profession">
                            <span className="text">
                            I'm{" "}
                            <span className="auto-input pro_text">
                                <Typed
                                strings={[
                                    "an Engineer",
                                    "a PhD Student",
                                    "a Programmer",
                                    "a Freelancer",
                                    "a Web Designer",
                                    "a Videogame Developer",
                                    "an AI Researcher",
                                ]}
                                typeSpeed={100}
                                backSpeed={100}
                                loop
                                />
                            </span>
                            </span>
                        </div>

                        <p className="Portafolio__header-description">
                            I design efficient Deep Learning models for Image and Video processing tasks
                            and build modern web experiences for real-world projects.
                        </p>

                        <div className="Portafolio__header-actions">
                            <Button href={CV} target="_blank">
                            Download CV
                            </Button>
                        </div>

                        <div className="Portafolio__stats">
                            <div className="Portafolio__stat-card">
                            <h3>5+</h3>
                            <p>Years of building software</p>
                            </div>

                            <div className="Portafolio__stat-card">
                            <h3>2+</h3>
                            <p>Papers published</p>
                            </div>

                            <div className="Portafolio__stat-card">
                            <h3>6+</h3>
                            <p>Years of engineering</p>
                            </div>
                        </div>
                    </div>
            </section>

            <section className="landing-projects-section">

                <div className="glitch_section" data-text="Latest projects">Latest projects</div>

                <ProjectCard
                    title="UEC International Week 2026"
                    description="Official event website for UEC International Week 2026, designed to present schedules, activities, and international programs in a clear and accessible format for students, guests, and university visitors."
                    image={UEC_IW}
                    imageAlt="UEC International Week 2026 project preview"
                    countryFlag={japan}
                    countryName="Japan"
                    tools={[
                        { name: "HTML", icon: html },
                        { name: "CSS", icon: css },
                        { name: "JavaScript", icon: javascript },
                    ]}
                    projectUrl="https://www.uec.ac.jp/international_week/"
                    layout="wide"
                />

                <ProjectCard
                    title="WILJO Vending"
                    description="Business website for a U.S.-based full-service vending company, showcasing arcade machines, pool tables, jukeboxes, ATMs, and entertainment services for bars, restaurants, and commercial venues."
                    image={wiljo}
                    imageAlt="WILJO Vending project preview"
                    countryFlag={usa}
                    countryName="United States"
                    tools={[
                        { name: "HTML", icon: html },
                        { name: "CSS", icon: css },
                        { name: "JavaScript", icon: javascript },
                        { name: "React", icon: react },
                    ]}
                    projectUrl="https://wiljovending.com/"
                    layout="reverse"
                />

                <ProjectCard
                    title="Jagaimo Club"
                    description="Website for a long-standing Japanese club founded in 1954, presenting its history, activities, and official information through a clean and structured digital platform."
                    image={jagaimo}
                    imageAlt="Jagaimo Club project preview"
                    countryFlag={japan}
                    countryName="Japan"
                    tools={[
                        { name: "HTML", icon: html },
                        { name: "CSS", icon: css },
                        { name: "JavaScript", icon: javascript },
                    ]}
                    projectUrl="http://www.jc-jagaimoclub.jp/index.html"
                    layout="wide"
                />

                <ProjectCard
                    title="AVAG | IC"
                    description="Corporate website for a Mexican construction company, designed to communicate its values, services, and project expertise with a professional and trustworthy digital presence."
                    image={avag}
                    imageAlt="AVAG | IC project preview"
                    countryFlag={mexico}
                    countryName="Mexico"
                    tools={[
                        { name: "HTML", icon: html },
                        { name: "CSS", icon: css },
                        { name: "JavaScript", icon: javascript },
                    ]}
                    projectUrl="https://www.avagic.com/"
                    layout="reverse"
                />

            </section>


            <section className="publications-section">

                <div className="glitch_section" data-text="Recient Publications">Recient Publications</div>

                {/* <PublicationCard
                    title="EGAMNet: Enhanced Graph Attention MLP Network for Efficient 3D Human Pose Estimation"
                    conference="23rd Advanced Concepts for Intelligent Vision Systems (ACIVS), December 15-17, 2026, Okinawa, Japan"
                    countryFlag={japan}
                    countryName="Japan"
                    image={egamnet}
                    imageAlt="EGAMNet paper preview"
                    abstract="Graph convolutional networks provide an efficient way to model the human skeleton for 3D human pose estimation, but their ac- curacy often remains below that of recent transformer-based methods. This paper presents EGAMNet, an enhanced graph-attention MLP net- work designed as a graph-centered architecture for accurate and efficient 3D pose lifting. EGAMNet follows a branch-specific design composed of a Spatial Graph-Attention Branch and a Channel Graph-Attention Branch. The spatial branch integrates spatio-temporal graph convolu- tion with spatial feature mixing and efficient spatial attention to model anatomical dependencies and short-term motion cues, while the chan- nel branch uses graph-based channel refinement with efficient channel attention to preserve lightweight feature interaction. Experiments on Human3.6M and MPI-INF-3DHP show that EGAMNet improves the accuracy-efficiency trade-off among lightweight graph-based methods. In particular, EGAMNet achieves 43.1 mm MPJPE on Human3.6M while requiring only 172 MFLOPs and 0.21 ms inference time for 243-frame in- puts using a single RTX 3060 GPU. The results indicate that selectively applying spatio-temporal graph reasoning in the spatial branch improves pose estimation accuracy with only a small computational overhead."
                    paperUrl=""
                    codeUrl=""
                    readMoreUrl=""
                    layout="wide"
                /> */}

                <PublicationCard
                    title="GAMNet: Graph Attention Mlp-Based Network for 3D Human Pose Estimation"
                    conference="40th International Conference on Image and Vision Computing New Zealand (IVCNZ), December 19-20, 2025, Wellington, New Zealand"
                    countryFlag={newZealand}
                    countryName="New Zealand"
                    image={gamnet}
                    imageAlt="GAMNet paper preview"
                    abstract="Graph convolutional networks (GCNs) and their variants have shown significant promise in 3D human pose estimation, but despite their efficiency advantages they still lag slightly behind recent Transformer-based methods in accuracy. To bridge this gap, we propose GAMNet: an Efficient Graph Attention MLP-based Network that unifies adaptive graph convolutions with lightweight MLP blocks, augmented by efficient channel and spatial attention mechanisms. Specifically, GAMNet learns skeleton topology via an adaptive graph modules that refines the graph structure during training, recalibrates feature channels using an Efficient Channel Attention block to emphasize informative dimensions, and highlights salient joint interactions with a lightweight Spatial Attention. By integrating these components within a dual-branch GCN-MLP architecture, GAMNet effectively models both local skeletal connectivity and global contextual dependencies with minimal overhead. Extensive experiments on Human3.6M and MPI-INF-3DHP demonstrate that GAMNet requires only 8.97 M parameters and 157 MFLOPs for a 243 -frame input to surpass the accuracy of leading Graph-based methods and show competitive results compared with strong Transformer-based methods with lower computational cost."
                    paperUrl="https://ieeexplore.ieee.org/document/11281821"
                    codeUrl=""
                    readMoreUrl="https://ieeexplore.ieee.org/document/11281821"
                    layout="reverse"
                />

                <PublicationCard
                    title="YOLOv5 with Mixed Backbone for Efficient Spatio-Temporal Hand Gesture Localization and Recognition"
                    conference="18th International Conference on Machine Vision Applications (MVA), July 23-25, 2023, Hamamatsu, Japan"
                    countryFlag={japan}
                    countryName="Japan"
                    image={yolo3d}
                    imageAlt="YOLOv5 with Mixed Backbone paper preview"
                    abstract="Spatio-temporal Hand Gesture Localization and Recognition is an emerging topic due to the increasing popularity of hand movements for interaction with digital devices. This paper proposes an efficient approach for recognizing and localizing hand gestures from video sequences."
                    paperUrl="https://ieeexplore.ieee.org/document/10215605"
                    codeUrl=""
                    readMoreUrl="https://ieeexplore.ieee.org/document/10215605"
                    layout="wide"
                />

            </section>


        </div>
    );
};

export default Landing;